import React from "react";
import useStyles from "./styles";
import { Box, Container, Hidden } from "@material-ui/core";

const PageHeader = ({ title, nextPrevious, children, containerWidth }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Container maxWidth={containerWidth}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <Hidden xsDown>
              <h1 className={classes.pageHeader}>{title}</h1>
            </Hidden>
            {nextPrevious ? nextPrevious : ""}
          </Box>
          <Box className={classes.headerAction}>{children}</Box>
        </Box>
      </Container>
    </Box>
  );
};

export default PageHeader;
